import React, { useState, useEffect } from "react";
import { db } from "../../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";

const CarsList = () => {
  const [cars, setCars] = useState([]);

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "cars"));
        const carsData = [];
        querySnapshot.forEach((doc) => {
          carsData.push({ id: doc.id, ...doc.data() });
        });
        setCars(carsData);
      } catch (error) {
        console.error("Error fetching cars:", error);
      }
    };

    fetchCars();
  }, []);

  const containerStyle = {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f4f6f8",
    minHeight: "100vh",
  };

  const headerStyle = {
    textAlign: "center",
    marginBottom: "20px",
    color: "#333",
  };

  const cardContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    justifyContent: "center",
  };

  const cardStyle = {
    width: "300px",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    transition: "transform 0.2s",
  };

  const cardHoverStyle = {
    ...cardStyle,
    transform: "scale(1.03)",
  };

  const imageStyle = {
    width: "100%",
    height: "200px",
    objectFit: "cover",
  };

  const cardContentStyle = {
    padding: "15px",
    color: "#333",
  };

  const cardTitleStyle = {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "10px",
  };

  const cardTextStyle = {
    fontSize: "14px",
    marginBottom: "8px",
  };

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>All Cars</h1>
      <div style={cardContainerStyle}>
        {cars.length > 0 ? (
          cars.map((car) => (
            <div
              key={car.id}
              style={cardStyle}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.03)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <img
                src={car.pictures?.[0] || "https://via.placeholder.com/300x200"}
                alt={car.carName || "Car Image"}
                style={imageStyle}
              />
              <div style={cardContentStyle}>
                <h2 style={cardTitleStyle}>{car.carName || "Unnamed Car"}</h2>
                <p style={cardTextStyle}>
                  <strong>Total Value:</strong> $
                  {car.totalValue?.toLocaleString() || "N/A"}
                </p>
                <p style={cardTextStyle}>
                  <strong>Money Raised:</strong> $
                  {car.moneyRaised?.toLocaleString() || "N/A"}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p style={{ textAlign: "center", color: "#555" }}>
            No cars found in the collection.
          </p>
        )}
      </div>
    </div>
  );
};

export default CarsList;
